<template>
  <el-dialog title="用户协议" :visible="onOff" append-to-body :before-close="handleClose" center>
    <div class="text-left">
      <p>经营帮用户服务协议</p>
      <p>本协议是您与经营帮网站（简称"本站"，网址：<a class="hover_02" target="_blank" href="http://www.jingyingbang.com">www.jingyingbang.com</a>）所有者中钧科技有限公司（以下简称为"经营帮"）之间就经营帮网站服务等相关事宜所订立的契约，请您仔细阅读本注册协议，您点击"同意"按钮后，本协议即构成对双方有约束力的法律文件。</p>
      <div class="tc-10"></div>
      <p>第1条 本站服务条款的确认和接纳</p>
      <p class="p2">1.1本站的各项在线服务的所有权和运作权归经营帮所有。用户同意所有注册协议条款并完成注册程序，才能成为本站的正式用户。用户确认：本协议条款是处理双方权利义务的契约，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定。</p>
      <p class="p2">1.2用户点击同意本协议，即视为用户确认自己具有享受在线购买及享受服务等相应的权利和行为能力，能够独立承担法律责任。</p>
      <p class="p2">1.3经营帮保留在中华人民共和国法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容或取消订单的权利。</p>
      <div class="tc-10"></div>
      <p>第2条 本站服务</p>
      <p class="p2">2.1经营帮通过互联网依法为用户提供产品信息等服务，用户在完全同意本协议及本站规定的情况下，方有权使用本站的相关服务。</p>
      <div class="tc-10"></div>
      <p>第3条 用户信息</p>
      <p class="p2">3.1用户应本着个人或企业诚信向本站提供注册资料，用户同意其提供的注册资料真实、准确、完整、合法有效，用户注册资料如有变动的，应及时更新其注册资料。如果用户提供的注册资料不合法有效、不真实、不准确、不详尽的，用户需承担因此引起的相应责任及后果，并且经营帮保留终止用户使用经营帮各项服务的权利。</p>
      <p class="p2">3.2用户在本站进行浏览、下单等操作时，涉及用户及企业真实姓名/名称、通信地址、联系方式、营业执照等隐私信息的，本站将予以严格保密，除非得到用户授权或法律另有规定，本站不会向外界披露用户及企业隐私信息。</p>
      <p class="p2">3.3用户注册成功后，将产生密码等账户信息，您可以根据本站提示修改您的密码。用户应谨慎合理的保存、使用其密码。用户若发现任何非法使用用户账号或存在安全漏洞的情况，请立即通知本站。否则，由于用户自身的疏忽而导致账号信息泄露等后果，由用户自行承担。</p>
      <p class="p2">3.4用户同意，经营帮拥有通过邮件、短信、电话等形式，向在本站注册、购物的用户发送订单信息、促销活动等告知信息的权利。</p>
      <p class="p2">3.5用户若将在本站注册获得的账户借给他人使用，则必须承担由此产生的全部责任，且实际使用人需承担连带责任。</p>
      <p class="p2">3.6用户同意，经营帮有权使用用户的注册信息、密码等信息，登陆进入用户的注册账户，进行证据保全，包括但不限于公证、见证等。</p>
      <div class="tc-10"></div>
      <p>第4条 账户说明</p>
      <p class="p2">4.1您应对您的手机号和密码的安全，以及对通过其手机号和密码实施的行为负责。您在经营帮注册的手机号 和密码仅限于您自身内部人员进行使用，不得给予任何第三方使用，否则由此造成的损失由您自行承担，且经营帮保留暂停或终止服务。</p>
      <p class="p2">4.2除非有法律规定或司法裁定，且征得经营帮的同意，否则，手机号和密码不能以任何方式转让、赠与或继承。</p>
      <p class="p2">4.3您遗忘或丢失在经营帮注册的密码时，可与经营帮客户服务人员取得联系，在提供相关证明资料并经经营帮审核确认后，可找回密码。</p>
      <div class="tc-10"></div>
      <p>第5条 信息的修改</p>
      <p class="p2">您注册为企业账号后，如注册登记信息发生变更，您必须及时、主动联系经营帮进行更新。因您未及时更新，造成您不能享受相关服务的、或造成账号及密码泄露等所有责任由您自行承担。</p>
      <div class="tc-10"></div>
      <p>第6条 用户依法言行义务</p>
      <p class="p2">本协议依据国家相关法律法规规章制定，用户同意严格遵守以下义务：</p>
      <p class="p2">（1）不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；</p>
      <p class="p2">（2）从中国大陆向境外传输资料信息时必须符合中国有关法规；</p>
      <p class="p2">（3）不得利用本站从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；</p>
      <p class="p2">（4）不得干扰本站的正常运转，不得侵入本站及国家计算机信息系统；</p>
      <p class="p2">（5）不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；</p>
      <p class="p2">（6）不得教唆他人从事本条款所禁止的行为；</p>
      <p class="p2">（7）不得利用在本站注册的账户进行非法牟利经营活动； 用户应不时关注并遵守本站不时公布或修改的各类合法规则规定。 本站保有删除站内各类不符合法律政策或不真实的信息内容而无须通知用户的权利。 若用户未遵守以上规定的，本站有权作出独立判断并采取暂停或关闭用户帐号等措施。用户须对自己在网上的言论和行为承担法律责任。</p>
      <div class="tc-10"></div>
      <p>第7条 商品信息</p>
      <p class="p2">本站上的货物价格、数量、是否有货等商品信息将根据市场行情及销售情况随时发生变动，本站不作特别通知。由于网站货物信息数量庞大，虽然本站会尽最大努力保证您所浏览商品信息的准确性，但由于网络及电脑终端兼容性等客观原因存在，本站网页显示的信息可能会有一定的滞后性或差错，对此情形请您知悉并理解；经营帮欢迎纠错，并会视情况给予纠错者一定的奖励。</p>
      <div class="tc-10"></div>
      <p>第8条 交易</p>
      <p class="p2">8.1您在商城下订单交易时，请您仔细确认所购货物的品名、价格、数量、材质、规格、企业名称、开票地址等信息。若您提供的信息错误导致交易过程中出现利益损失的，则经营帮将不承担相应法律责任及连带责任。</p>
      <p class="p2">8.2除法律另有强制性规定外，双方约定如下：本站展示的商品和价格等信息仅仅是经营帮的要约邀请，您下单时须填写您希望购买的商品数量、企业名称、提货方式、开票地址等内容；系统生成的订单信息是计算机信息系统根据您填写的内容自动生成的数据，仅是您向经营帮发出的合同要约；经营帮收到您的订单信息后，并收到您的打款及提货信息后，即视为您与经营帮之间建立了合同关系。</p>
      <p class="p2">8.3由于市场变化及各种以合理商业努力难以控制的因素的影响，本站无法保证您提交的订单信息中希望购买的商品都会有货；如您拟购买的商品，发生缺货，您有权取消订单。</p>
      <p class="p2">8.4商品价格，鉴于在B-to-B领域中商品价格可能具有商业机密性质的客观事实，商铺中陈列的商品价格信息仅供参考。如您通过经营帮在线交易服务购买商品，请意识到部分商铺的商品实际成交价格可能与陈列的价格不一致。在前述情况下，商品价格应确认“订单总金额”为准，前述“订单总金额”包含“货品总价”和“运费”，用户须在交易过程中对价格信息进行谨慎核对。</p>
      <div class="tc-10"></div>
      <p>第9条 提货</p>
      <p class="p2">9.1您在完成支付且您的提货函审核通过后，即可根据购销合同约定的信息，到指定仓库进行提货，或指定物流发货。</p>
      <p class="p2">9.2因如下情况造成无法提货等，经营帮及合作供应商不承担任何责任：</p>
      <p class="p3">（1）用户提供的提货信息错误导致的；</p>
      <p class="p3">（2）情势变更因素导致的；</p>
      <p class="p3">（3）不可抗力因素导致的，例如：自然灾害、交通戒严、突发战争等。</p>
      <div class="tc-10"></div>
      <p>第10条 责任限制及不承诺担保</p>
      <p class="p2">除非另有明确的书面说明,本站及其所包含的或以其它方式通过本站提供给您的全部信息、资料、货物（包括软件）和服务，均是在"按现状"和"按现有"的基础上提供的。 除非另有明确的书面说明,经营帮不对本站的运营及其包含在本网站上的信息、资料、货物（包括软件）和服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。 如因不可抗力或其它本站无法控制的原因使本站销售系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，经营帮会合理地尽力协助处理善后事宜。</p>
      <div class="tc-10"></div>
      <p>第11条 协议更新及用户关注义务</p>
      <p class="p2">11.1根据国家法律法规变化及网站运营需要，经营帮有权对本协议条款不时地进行修改，修改后的协议一旦被张贴在本站上即生效，并代替原来的协议。用户可随时登陆查阅最新协议；用户有义务不时关注并阅读最新版的协议及网站公告。如用户不同意更新后的协议，可以且应立即停止接受经营帮依据本协议提供的服务；如用户继续使用本网站提供的服务的，即视为同意更新后的协议。经营帮建议您在使用本站之前阅读本协议及本站的公告。 如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。</p>
      <p class="p2">11.2任何经经营帮确认已经违反相关法律法规或本协议或经营帮使用规则某一项或多项规定的用户，经营帮有权决定是否给予暂停使用或终止使用的处理，且因此造成的一切后果由用户自行承担。</p>
      <p class="p2">11.3客户与经营帮基于交易合作签署的其他书面协议与本协议不一致的，以双方书面签署的协议为准。</p>
      <div class="tc-10"></div>
      <p>第12条 法律管辖和适用</p>
      <p class="p2">本协议的订立、执行和解释及争议的解决均应适用在中华人民共和国大陆地区适用之有效法律（但不包括其冲突法规则）。 如发生本协议与适用之法律相抵触时，则这些条款将完全按法律规定重新解释，而其它有效条款继续有效。 如缔约方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向有管辖权的中华人民共和国大陆地区法院提起诉讼。</p>
      <div class="tc-10"></div>
      <p>第13条 其他</p>
      <p class="p2">13.1经营帮所有者是指在政府部门依法许可或备案的经营帮经营主体。</p>
      <p class="p2">13.2经营帮尊重用户和消费者的合法权利，本协议及本网站上发布的各类规则、声明等其他内容，均是为了更好的、更加便利的为用户和消费者提供服务。本站欢迎用户和社会各界提出意见和建议，经营帮将虚心接受并适时修改本协议及本站上的各类规则。</p>
    </div>

  </el-dialog>
</template>
<script>
export default {
  props: {
    onOff: {
      type: Boolean
    }
  },
  data () {
    return {}
  },
  methods: {
    handleClose () {
      this.$emit('update:onOff', false)
    }
  },
  created () {
  }
}
</script>
<style scoped>
p{
  text-indent: 0em;
  font-size: 14px;
}
.p2{
  text-indent: 2em;
}
.p3{
  text-indent: 4em;
}
h5{
  font-weight: bold;
}
.text-left {
  text-align: left;
}
</style>
